import { apiFetch } from "./api";

export async function uploadCsv(file) {
  const form = new FormData();
  form.append("file", file);

  return apiFetch("/imports/csv", {
    method: "POST",
    body: form,
  });
}

export async function getImportRows(importId) {
  return apiFetch(`/imports/${importId}/rows`);
}

export async function commitImport(importId) {
  return apiFetch(`/imports/${importId}/commit`, {
    method: "POST",
  });
}